import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function ContactQuickActions() {
  const actions = [
    {
      icon: "ri-team-line",
      title: "Explore Partnership",
      description: "Interested in PIIC, PTIM, or other programmes? Visit our collaboration page.",
      href: "/collaborate",
      cta: "Collaborate with TIE",
    },
    {
      icon: "ri-award-line",
      title: "Expo 2026",
      description: "Learn about the Textile Innovation Expo 12-14 November 2026 at ICCB Dhaka.",
      href: "https://www.textileinnovationexpo.com/",
      cta: "Visit Expo Website",
      external: true,
    },
    {
      icon: "ri-book-open-line",
      title: "Research & Publications",
      description: "Access IJTAI journal articles, AIRCon proceedings, and PIARC research findings.",
      href: "/programs",
      cta: "View Programmes",
    },
  ];

  return (
    <section className="bg-tie-cream-warm py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-10 md:mb-14">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-tie-text-primary">
                Not Sure Where to Start?
              </h2>
              <p className="mt-3 text-base text-tie-text-secondary max-w-2xl mx-auto">
                Here are quick pathways based on what you are looking for.
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {actions.map((action, i) => (
              <ScrollReveal key={action.title} delay={i * 100}>
                <div className="bg-white rounded-xl p-6 md:p-7 border border-tie-grey h-full flex flex-col">
                  <div className="w-12 h-12 rounded-lg bg-tie-navy/5 flex items-center justify-center mb-4">
                    <div className="w-6 h-6 flex items-center justify-center text-tie-teal">
                      <i className={action.icon} />
                    </div>
                  </div>
                  <h3 className="text-base font-semibold text-tie-text-primary mb-2">
                    {action.title}
                  </h3>
                  <p className="text-sm text-tie-text-secondary leading-relaxed mb-5 flex-1">
                    {action.description}
                  </p>
                  {action.external ? (
                    <a
                      href={action.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center text-sm font-medium text-tie-teal hover:text-tie-teal-dark transition-colors whitespace-nowrap"
                    >
                      {action.cta}
                      <i className="ri-external-link-line ml-1.5" />
                    </a>
                  ) : (
                    <Link
                      to={action.href}
                      className="inline-flex items-center text-sm font-medium text-tie-teal hover:text-tie-teal-dark transition-colors whitespace-nowrap"
                    >
                      {action.cta}
                      <i className="ri-arrow-right-line ml-1.5" />
                    </Link>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}